import { queryOptions, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { BUYER_CATEGORY_CODES } from '@/utils/buyerCategoryCounts';

export const buyerCategoryCountsQueryOptions = (country: string) => queryOptions({
  queryKey: ['buyer-category-counts', country],
  queryFn: async () => {
    const { data: categories, error: categoryError } = await supabase.from('categories').select('id,code');
    if (categoryError) throw categoryError;
    const ids = (codes: readonly string[]) => (categories ?? []).filter(c => codes.includes(c.code)).map(c => c.id);
    const counts = await Promise.all(Object.values(BUYER_CATEGORY_CODES).map(async codes => {
      const categoryIds = ids(codes);
      if (!categoryIds.length) return 0;
      const { count, error } = await supabase.from('listings_v2').select('id', { count: 'exact', head: true })
        .eq('status', 'active').eq('country_code', country).in('category_id', categoryIds);
      if (error || count == null) throw error ?? new Error('Category count unavailable');
      return count;
    }));
    return { used: counts[0], truck: counts[1], motorcycle: counts[2] };
  },
  staleTime: 60 * 1000,
});

export const useBuyerCategoryCounts = (country: string) => useQuery(buyerCategoryCountsQueryOptions(country));